import styled from 'styled-components/macro'

export default styled.header`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  background-color: rgba(${p => p.theme.color.light}, 1);
  background-image: url('${process.env.PUBLIC_URL}/img/tree_bark3.png');
  background-attachment: fixed;
  box-shadow: inset 0 -15px 15px -15px rgba(0, 0, 0, 0.2);
  height: ${p => p.height};
  padding: ${p => p.theme.spacing};
`
